<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="基础信息">
        <table cellspacing="0" cellpadding="0" class="defaultTable" style="width: 100%;">
          <tr>
            <td class="tableLabel">系统编号：</td>
            <td>{{disassembleOrder.billNo}}</td>
            <td class="tableLabel">申请人人：</td>
            <td>{{disassembleOrder.creatorName}}</td>
            <td class="tableLabel">申请日期：</td>
            <td>{{disassembleOrder.createTime}}</td>
          </tr>
          <tr>
            <td class="tableLabel">提交时间：</td>
            <td>{{disassembleOrder.submitTime}}</td>
            <td class="tableLabel">退料单号：</td>
            <td>{{disassembleOrder.returnOrderNo}}</td>
            <td class="tableLabel">出厂编号：</td>
            <td>{{disassembleOrder.factoryNo}}</td>
          </tr>
          <tr>
            <td class="tableLabel">处理类型：</td>
            <td>
              {{constant.dealType[disassembleOrder.dealType]}}
            </td>
            <td class="tableLabel">拆解号：</td>
            <td>{{disassembleOrder.disassemblyNo}}</td>
            <td class="tableLabel">流程状态：</td>
            <td>{{disassembleOrder.nodeDesc}}</td>
          </tr>
        </table>
        <div>
          <div
              style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
            物料信息
          </div>
          <el-table
              :data="disassembleOrder.details">
            <el-table-column prop="materialNo" align="center" label="物料编号"/>
            <el-table-column prop="materialName" align="center" label="物料名称"/>
            <el-table-column prop="quantity" align="center" label="数量"/>
            <el-table-column prop="unit" align="center" label="单位"/>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
    <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
  </div>
</template>
<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import constant from "@/util/constant";

  export default {
    name: "DisassembleOrderPreview",
    components: {HandleDetail},
    props: {
      billId: {
        type: String,
        required: true,
      },
      billType: {
        type: String,
        required: true,
      },
      sequId: {
        type: String,
        required: true,
      },
      params: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        saveLoading: false,
        constant,
        nodeId: 0,
        disassembleOrder: {
          pkid: "",
          billNo: "",
          creatTime: "",
        },
      };
    },
    watch: {
      params: {
        handler() {
          this.toDoApprove();
        },
      },
    },
    mounted() {
      this.getData();
      this.getNodeValue();
    },
    methods: {
      getData() {
        this.$http.get("basic", `disassembleOrders/${this.billId}`).then((res) => {
          this.disassembleOrder = res;
        }).catch(() => {
        });
      },
      toDoApprove() {
        console.log(this.params);
        if (this.params.actionType === 0) {
          // if (this.nodeId === "contractPreReview") {
          //   this.disassembleOrder.details.forEach((item) => {
          //     if (item.remark === "" || item.remark == null) {
          //       return this.$message.error("处理意见不能为空！！！");
          //     }
          //   });
          //   this.toSave();
          // }
        }
        if (this.params.untreadedFlowId === "0;submitter" && this.params.actionType === 2) {
          this.updateStatus();
        }
        let approveVar = "";
        if (this.params.actionType === 0) {
          let list = this.params.applicationVarVOS;
          if (list.length > 0) {
            for (let i = 0; i < list.length; i++) {
              if (i === list.length - 1) {
                approveVar += list[i].varName + "#" + list[i].varValue;
              } else {
                approveVar += list[i].varName + "#" + list[i].varValue + "|";
              }
            }
          }
        }
        let params = {
          billId: parseInt(this.billId),
          billType: parseInt(this.billType),
          sequId: parseInt(this.sequId),
          actionType: this.params.actionType,
          approveNote: this.params.approveNote,
          untreadedFlowId: this.params.untreadedFlowId,
          transferTo: this.params.transferTo,
          approveVar: approveVar,
          billParam: "",
        };
        this.doApprove(params);
      },
      toSave() {
        this.saveLoading = true;
        this.$http
          .put("basic", "disassembleOrders/updateDetail", this.disassembleOrder)
          .then(() => {
            // this.$message.success("保存成功");
            this.saveLoading = false;
          }).catch(() => {
            this.saveLoading = false;
          });
      },
      doApprove(params) {
        this.$emit("loading-status", {"loading": true});
        this.$http
          .post("basic", "applications/doApprove", params)
          .then(() => {
            this.$emit("loading-status", {"loading": false});
            this.$message.success("操作成功");
            // 关闭标签
            this.$bus.$emit("closeTag", this.$route);
            this.$router.push({
              path: "/workFlow/csSpecialApprove",
            });
          }).catch(() => {
            this.$emit("loading-status", {"loading": false});
          });
      },
      updateStatus() {
        this.$http
          .get("basic", `disassembleOrders/back/${this.disassembleOrder.pkid}`)
          .then(() => {
            this.$message.success("退回到提交人成功！！！");
          });
      },
      getNodeValue() {
        let params = {
          "billType": this.billType,
          "billId": this.billId,
          "sequId": this.sequId,
        };
        this.$http
          .get("basic", "applications/approve", params)
          .then(resp => {
            this.nodeId = resp.nodeId;
            console.log(this.nodeId);
          });
      },
    },
  };
</script>
<style lang="scss">
table.defaultTable {
  font-family: verdana, arial, sans-serif;
  font-size: 11px;
  color: #333333;
  border-left: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}

table.defaultTable th {
  text-align: left;
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ebeef5;
  background-color: #f4f7fa;
}

table.defaultTable td {
  padding: 8px;
  border-right: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
}

.tableLabel {
  width: 10%;
  text-align: right;
  background-color: #D1E6F5;
}
</style>
